import { motion } from "framer-motion";
import FooterLinks from "./FooterLinks";

const FooterBottom = ({ currentYear }) => {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 2, duration: 0.5 }}
      className="flex flex-col md:flex-row justify-between items-center mt-8"
    >
      <p className="text-white text-sm mb-2 md:mb-0">
        <a href="https://www.linkedin.com/in/sertacgultekin/" className="text-white hover:text-gray-400">
          © {currentYear} sertacgltkn | All rights reserved.
        </a>
      </p>
      <FooterLinks />
    </motion.div>
  );
};

export default FooterBottom;
